import { render } from "./StatisticsAdminComponent.vue?vue&type=template&id=22c2b96e"
import script from "./StatisticsAdminComponent.vue?vue&type=script&lang=js"
export * from "./StatisticsAdminComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__